import {inject, Injectable} from '@angular/core';
import {environment} from '@/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

export interface FaceItLeaderboard {
	name: string;
	avatar: string;
	played: number;
	won: number;
	lost: number;
	draw: number;
	points: number;
	rankChange: number;
	teamId: string;
}

@Injectable({
	providedIn: 'root'
})
export class FaceitService {

	private readonly SERVICE_URI = `${environment.backendUrl}/faceit`;

	private readonly http: HttpClient = inject(HttpClient);

	getLeaderboard(): Observable<FaceItLeaderboard[]> {
		return this.http.get<FaceItLeaderboard[]>(`${this.SERVICE_URI}`);
	}

}
